import { OURSERVICES_SERVICE } from "@/services/services.service.js";

const state = { listOutput: null};

const actions = {
    getList({ dispatch, commit }, inputGetService) {
        dispatch('alert/clear', null, { root: true });
        commit('listRequest');
        
        OURSERVICES_SERVICE.list(inputGetService)
            .then(
                output => {
                    commit('listSuccess', output);
                },
                error => {
                    commit('listFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    /* List */
    listRequest(state) {
        state.listOutput = null;
    },
    listSuccess(state, output) {
        state.listOutput = output;
    },
    listFailure(state) {
        state.listOutput = false;
    },
};

export const ourServices = {
    namespaced: true,
    state,
    actions,
    mutations
};